import { useEffect } from 'react'
import { useQueryParam, StringParam } from 'use-query-params'
import { logout } from '../../api/auth/auth'
import Loader from '../../components/Loader'

const Logout = () => {
  const [redirectUrl] = useQueryParam('redirectUrl', StringParam)

  useEffect(() => {
    logout()
    window.location.href = redirectUrl || process.env.REACT_APP_URL_MAIN
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div>
      <Loader />
    </div>
  )
}
export default Logout
